
import { Component, Vue } from 'vue-property-decorator'
import { AdWxAppClient } from '@/api'
import AdWxAppEditor from './editor.vue'
import BaseList from '@/views/BaseList'
import _ from 'lodash'
import { setTimeout } from 'timers'

@Component({
  name: 'AdWxAppList',
  components: {
    AdWxAppEditor
  }
})
export default class extends BaseList {
  public constructor() {
    super()
    this.client = new AdWxAppClient()
    this.listQuery = {
      filter: {
        fields: {
          id: true,
          cover_img: true,
          detail_img: true,
          type: true,
          title: true,
          order: true,
          url: true,
          createdAt: true
        },
        limit: 10,
        page: 1,
        skip: 0,
        order: ['order ASC']
      }
    }
  }

  async created() {
    super.created()
  }

  protected generateQuery(): any {
    const t = _.cloneDeep(this.listQuery)
    return t
  }

  protected async handleFilter() {
    super.handleFilter()
  }

  protected async handleSizeChange(val: number) {
    super.handleSizeChange(val)
  }

  protected async handleCurrentChange(val: number) {
    super.handleCurrentChange(val)
  }

  protected async handleCreate() {
    super.handleCreate()
  }

  protected async handleUpdate(row: any) {
    super.handleUpdate(row)
  }

  protected async handleDelete(row: any) {
    super.handleDelete(row)
  }

  protected async saveData() {
    super.saveData()
  }
  protected typeFormatter(val: any) {
    let type = val.type
    if (type === 'index') {
      return '首页展示'
    } else if (type === 'pay_complete') {
      return '支付完成页展示'
    }
  }
}
